// @flow
import connectWebActions from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents } from 'fg-frontend/src/webComponents/decorate';
import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
import safeBlankLinks from 'fg-frontend/src/components/safeBlankLinks';
import cookiesPolicy from 'fg-frontend/components/CookiesPolicy4/index';
// import phoneLink                     from 'fg-frontend/components/PhoneLink';
import configureWebComponents from './configureWebComponents';
import configureWebActions from './configureWebActions';
import 'fg-frontend/ramjet/liveValidation';
import 'bootstrap/js/dist/collapse';

cookiesPolicy({
  enableImg: false,
  enableSplitGTMContainer: true,
});
connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, ['keyup']);
autoTitleLinksWithBlankTarget();

// Mastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();



// WEBPACK FOOTER //
// ./fe/web-eshop/src/js/configureWeb.js